export default __webpack_public_path__ + "static/media/productionwhite.23c9d9f7.png";